// String enums for accounting-calendar custom tags. These mirror the backend enums
// (com.amazon.ictpe.dataaccess.util.enums.*) and the Smithy DeleteScope enum — each member's
// value equals the backend `.name()` string sent/received over the API, so they are wire-safe.

export enum DateType {
    CALENDAR_DATE = 'CALENDAR_DATE',
    ACCOUNTING_DATE = 'ACCOUNTING_DATE',
}

export enum Recipients {
    ALL_ADMIN_USERS = 'ALL_ADMIN_USERS',
    ALL_ACCOUNTING_USERS = 'ALL_ACCOUNTING_USERS',
    ALL_TAX_USERS = 'ALL_TAX_USERS',
    ALL_USERS = 'ALL_USERS',
}

export enum RecurringFrequency {
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    YEARLY = 'YEARLY',
}

export enum DeleteScope {
    SINGLE = 'SINGLE',
    RECURRENCE = 'RECURRENCE',
}
